var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('button',{staticClass:"btn",on:{"click":_vm.clk}},[_vm._v("测试获取")])])
}
var staticRenderFns = []

export { render, staticRenderFns }